import { defaults } from 'lodash';
import {
  APPS_MAX_HEIGHT,
  APPS_MAX_WIDTH,
  CHAT_GPT_APP_DEFAULT_WIDTH,
  CHAT_GPT_APP_DEFAULT_HEIGHT,
  CHAT_GPT_MIN_WIDTH,
  CHAT_GPT_MIN_HEIGHT,
} from '../../iframe/additional-apps.utils';
import { FrameItem } from '../../../../models/session';
import { GPTApp, GptAppConfig } from '../../../../services/space-apps.service';
import { BoardItemConfig, CreationContext } from './board-item-configurations';

export class BoardChatGptConfigurations extends BoardItemConfig {
  appConfig: GptAppConfig;
  isPrivate: boolean;
  interactionsLocked: boolean;
  // The field used to communicate to the server, to determine the chat instance
  chatId: string = '';

  static defaultBoardItemConfigurations: Partial<BoardItemConfig> = {
    width: CHAT_GPT_APP_DEFAULT_WIDTH,
    height: CHAT_GPT_APP_DEFAULT_HEIGHT,
    minWidth: CHAT_GPT_MIN_WIDTH,
    maxWidth: APPS_MAX_WIDTH,
    minHeight: CHAT_GPT_MIN_HEIGHT,
    maxHeight: APPS_MAX_HEIGHT,
  };

  constructor(
    configurations: Partial<BoardChatGptConfigurations> & Partial<BoardItemConfig>,
    globalCreationParams: CreationContext,
  ) {
    super(
      {
        ...BoardChatGptConfigurations.defaultBoardItemConfigurations,
        ...configurations,
      },
      globalCreationParams,
    );

    const defaultChatGptConfigurations = {
      appConfig: {} as GPTApp,
      isPrivate: false,
      interactionsLocked: false,
      chatId: '',
    };

    const chatGptConfigurations = defaults(configurations, defaultChatGptConfigurations);

    this.appConfig = chatGptConfigurations.appConfig;
    this.isPrivate = chatGptConfigurations.isPrivate;
    this.interactionsLocked = chatGptConfigurations.interactionsLocked;
    this.chatId = chatGptConfigurations.chatId;
  }

  static fromYCanvasItemObject(
    frameItem: FrameItem,
    globalCreationsParams: CreationContext,
  ): BoardChatGptConfigurations {
    const configurations = BoardItemConfig.fromYCanvasItemObject(
      frameItem,
      globalCreationsParams,
      BoardChatGptConfigurations.defaultBoardItemConfigurations,
    );

    return new BoardChatGptConfigurations(
      {
        ...configurations,
        appConfig: frameItem.gpt_state,
        isPrivate: frameItem.isPrivate ?? false,
        interactionsLocked: frameItem.interactionsLocked ?? false,
        chatId: frameItem.content_id,
      },
      globalCreationsParams,
    );
  }
}
